export function featureFlags(state = {}, action) {
  switch (action.type) {
    case 'INITIALIZATION_DATA': {
      return action.data.featureFlags || {};
    }
    case 'feature_flags/INITIALIZE': {
      return action.data.featureFlags || {};
    }
    default: {
      return state;
    }
  }
}
